<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-7 order-lg-2">
                    <registration :registration="registration" :showButtons="false"></registration>

                    <tabs class="tabs"
                        tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pt-0"
                        tabContentClasses="card shadow">

                        <tab-pane id="sessions">
                            <span slot="title">{{ $t('common.simulations') }}</span>
                            <simulations
                                :registration="registration"
                                :simulations="simulations"
                                :ratings="simulationsRatings"
                                :rating-options="ratingOptions"
                            ></simulations>
                        </tab-pane>

                        <tab-pane id="grid1" :title="grid1Title">
                            <competencies
                                :registration="registration"
                                :competencies="competencies1"
                                :ratings="competenciesRatings1"
                                :rating-options="ratingOptions"
                                :position="registration.degree.simulation_role_1"
                            ></competencies>
                        </tab-pane>

                        <tab-pane id="grid2" :title="grid2Title" v-if="registration.degree.simulation_role_2 && hasSecondGrid">
                            <competencies
                                :registration="registration"
                                :competencies="competencies2"
                                :ratings="competenciesRatings2"
                                :rating-options="ratingOptions"
                                :position="registration.degree.simulation_role_2"
                            ></competencies>
                        </tab-pane>
                    </tabs>
                </div>
                <div class="col-lg-5 order-lg-1">

                    <user-card :user="learner"
                        :cohort="registration.cohort"
                        @openCohort="openCohort">
                    </user-card>

                    <registrations :learner="learner"></registrations>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserCard from '../auth/components/UserCard'
    import Registration from '../dashboard/cohort/Registration';
    import Simulations from './cohort/RegistrationResultsSimulations'
    import Competencies from './cohort/RegistrationResultsCompetencies'
    import Registrations from './cohort/LearnerRegistrations';

    export default {

        components: {
            UserCard, Registrations, Registration, Simulations, Competencies,
        },

        data() {
            return {
                registration: null,
                learner: null,
                simulations: null,
                simulationsRatings: null,
                competencies1: null,
                competenciesRatings1: null,
                competencies2: null,
                competenciesRatings2: null,
                learners: null,
                ratingOptions: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('reports.cohorts'),
                        route: '/astral/ui/reports/cohorts'
                    },
                    {
                        name: this.$t('reports.cohort-degrees'),
                        route: '/astral/ui/reports/cohorts/' + this.registration.cohort.id + '/degrees'
                    },
                    {
                        name: this.$t('reports.cohort-results'),
                        route: '/astral/ui/reports/registrations/' + this.registration.id + '/cohorts/' + this.registration.cohort.id + '/results'
                    },
                    {
                        name: this.learner.name,
                    },
                ]
            },

            hasSecondGrid() {
                for (var index in this.simulations) {
                    if (this.simulations[index].grid2_id) {
                        return true
                    }
                }
                return false
            },

            grid1Title() {
                return this.$t('common.competencies') + (this.registration.degree.simulation_role_2 && this.hasSecondGrid
                    ? ': ' + this.registration.degree.simulation_role_1_name[this.registration.degree.lang]
                    : ''
                )
            },

            grid2Title() {
                return this.$t('common.competencies') + ': ' + this.registration.degree.simulation_role_2_name[this.registration.degree.lang]
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/reports/registrations/'+to.params.registrationId+'/learners/'+to.params.learnerId+'/results')
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                    vm.learner = resp.data.included.learner
                    vm.simulations = resp.data.included.simulations
                    vm.simulationsRatings = resp.data.included.simulations_ratings
                    vm.competencies1 = resp.data.included.competencies_1
                    vm.competenciesRatings1 = resp.data.included.competencies_ratings_1
                    vm.competencies2 = resp.data.included.competencies_2
                    vm.competenciesRatings2 = resp.data.included.competencies_ratings_2
                    vm.learners = resp.data.included.learners
                    vm.ratingOptions = resp.data.included.rating_options
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        watch: {
            // Transversal registrations navigation causes change of registration ID without reloading the component.
            // So we need to refresh the component manually.
            '$route.params.registrationId': function (id) {
                this.refresh(id, this.learner.id);
            },
        },

        methods: {

            refresh(registrationId, learnerId) {
                axios.get('/astral/api/front/reports/registrations/'+registrationId+'/learners/'+learnerId+'/results')
                .then(resp => {
                    this.registration = resp.data.data
                    this.learner = resp.data.included.learner
                    this.simulations = resp.data.included.simulations
                    this.simulationsRatings = resp.data.included.simulations_ratings
                    this.competencies1 = resp.data.included.competencies_1
                    this.competenciesRatings1 = resp.data.included.competencies_ratings_1
                    this.competencies2 = resp.data.included.competencies_2
                    this.competenciesRatings2 = resp.data.included.competencies_ratings_2
                    this.learners = resp.data.included.learners
                    this.ratingOptions = resp.data.included.rating_options
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },

            openCohort() {
                this.$router.push({
                    name: 'report-cohort-registration-results',
                    params: {
                        cohortId: this.registration.cohort.id,
                        registrationId: this.registration.id,
                    }
                });
            },
        }
    }
</script>
